/* Íconos del hub: SVG inline, sin librería.
 *
 * Por qué inline y no un kit (Font Awesome, MUI…): el hub es liviano a
 * propósito. Cada ícono son unos pocos trazos que se dibujan con `currentColor`
 * —así siguen el tema claro/oscuro solos— y no agregan ninguna dependencia ni
 * peso más allá de los paths que se usan. Estilo Lucide/Feather (línea, 24x24).
 *
 * NADA de logos de marca: para YPF va un surtidor genérico, no el logo real
 * (es marca registrada). La idea es un símbolo que se reconozca, no el logo.
 */

const TRAZOS = {
  // Tráfico — camión
  trafico: <><rect x="1" y="6" width="13" height="10" rx="1" /><path d="M14 9h3.5l3.5 3.5V16h-7z" /><circle cx="5.5" cy="18" r="1.7" /><circle cx="17.5" cy="18" r="1.7" /></>,
  // YPF — surtidor (genérico, no el logo)
  surtidor: <><path d="M4 21V5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v16" /><line x1="4" y1="21" x2="13" y2="21" /><rect x="6" y="6" width="5" height="4" rx="0.5" /><path d="M13 9h3a2 2 0 0 1 2 2v6a1.5 1.5 0 0 0 3 0v-6l-2-2" /></>,
  // Fueguino — caja / encomienda
  caja: <><path d="M21 8l-9-5-9 5v8l9 5 9-5z" /><path d="M3 8l9 5 9-5" /><line x1="12" y1="13" x2="12" y2="22" /></>,
  // Mi espacio — grilla
  grilla: <><rect x="3" y="3" width="18" height="18" rx="1.5" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="3" y1="15" x2="21" y2="15" /><line x1="9" y1="3" x2="9" y2="21" /><line x1="15" y1="3" x2="15" y2="21" /></>,
  // Automatizaciones — rayo (algo que pasa solo)
  rayo: <><path d="M13 2L4 14h7l-1 8 9-12h-7z" /></>,
  // Novedades — campana
  campana: <><path d="M6 9a6 6 0 0 1 12 0c0 4 1.5 5 2 6H4c.5-1 2-2 2-6" /><path d="M10 19a2 2 0 0 0 4 0" /></>,
  // Padrones — gente
  gente: <><circle cx="9" cy="8" r="3" /><path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" /><path d="M16 6a3 3 0 0 1 0 6" /><path d="M17.5 14.2c1.8.3 3.5 1.8 3.5 4.3" /></>,
  // Pañol — caja de herramientas
  panol: <><rect x="3" y="8" width="18" height="12" rx="1" /><path d="M8 8V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><line x1="3" y1="13" x2="21" y2="13" /><rect x="10" y="11" width="4" height="4" rx="0.5" /></>,
  // Portería — escudo (control de acceso)
  escudo: <><path d="M12 3l8 3v5c0 5-4 8-8 10-4-2-8-5-8-10V6z" /><path d="M9 12l2 2 4-4" /></>,
  // Comprobantes — recibo
  recibo: <><path d="M6 2h12v20l-3-2-3 2-3-2-3 2z" /><line x1="9" y1="8" x2="15" y2="8" /><line x1="9" y1="12" x2="15" y2="12" /></>,
  // Proveedores — billete (lo que se paga)
  billete: <><rect x="2" y="6" width="20" height="12" rx="1.5" /><circle cx="12" cy="12" r="2.6" /><line x1="5.5" y1="9.5" x2="5.5" y2="9.5" /><line x1="18.5" y1="14.5" x2="18.5" y2="14.5" /></>,
  // Aduana — sello (mango redondo, cuerpo que se abre a la base y el piso)
  sello: <><rect x="9.5" y="3.5" width="5" height="3.5" rx="1.75" /><path d="M8 13l1-5.5h6l1 5.5z" /><rect x="6.5" y="13" width="11" height="2.2" rx="0.5" /><line x1="5.5" y1="19" x2="18.5" y2="19" /></>,
  // Peajes — barrera de peaje
  barrera: <><rect x="3" y="7" width="4" height="13" rx="0.8" /><line x1="2" y1="20" x2="8" y2="20" /><rect x="7" y="8.5" width="14" height="3" rx="1" /><line x1="11" y1="8.5" x2="10" y2="11.5" /><line x1="15" y1="8.5" x2="14" y2="11.5" /><line x1="19" y1="8.5" x2="18" y2="11.5" /></>,
  // Dirección — brújula
  brujula: <><circle cx="12" cy="12" r="9" /><polygon points="16.5,7.5 13.5,13.5 7.5,16.5 10.5,10.5" /></>,
  // Presidencia — gráfico
  grafico: <><line x1="4" y1="20" x2="21" y2="20" /><rect x="6" y="12" width="3" height="8" rx="0.5" /><rect x="11" y="8" width="3" height="12" rx="0.5" /><rect x="16" y="4" width="3" height="16" rx="0.5" /></>,
  // Puerto — ancla
  ancla: <><circle cx="12" cy="5" r="2" /><line x1="12" y1="7" x2="12" y2="21" /><path d="M5 12a7 7 0 0 0 14 0" /><line x1="3" y1="12" x2="5" y2="12" /><line x1="19" y1="12" x2="21" y2="12" /></>,
  // RRHH — credencial
  credencial: <><rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="8" cy="11" r="2" /><path d="M5 16c0-1.6 1.4-2.5 3-2.5s3 .9 3 2.5" /><line x1="14" y1="10" x2="18" y2="10" /><line x1="14" y1="14" x2="18" y2="14" /></>,
  // Sistema — controles/sliders (más claro que un engranaje a este tamaño)
  engranaje: <><line x1="4" y1="8" x2="20" y2="8" /><circle cx="9" cy="8" r="2.3" /><line x1="4" y1="16" x2="20" y2="16" /><circle cx="15" cy="16" r="2.3" /></>,
  // TCC — edificio (la empresa)
  edificio: <><path d="M4 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16" /><path d="M14 21V10h4a2 2 0 0 1 2 2v9" /><line x1="7" y1="7" x2="11" y2="7" /><line x1="7" y1="11" x2="11" y2="11" /><line x1="7" y1="15" x2="11" y2="15" /></>,
  // Taller — llave
  llave: <><path d="M15 3a5 5 0 0 0-4.6 7l-6.7 6.7 2.6 2.6 6.7-6.7A5 5 0 1 0 15 3z" /><line x1="8" y1="16" x2="10" y2="18" /></>,
  // Inicio — casa
  casa: <><path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" /><rect x="10" y="14" width="4" height="6" /></>,
  // Menú — hamburguesa
  menu: <><line x1="4" y1="7" x2="20" y2="7" /><line x1="4" y1="12" x2="20" y2="12" /><line x1="4" y1="17" x2="20" y2="17" /></>,
  // Sin permiso — puerta cerrada
  puerta: <><path d="M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17" /><line x1="3" y1="21" x2="21" y2="21" /><circle cx="14.5" cy="12.5" r="0.9" /></>,
  // ¿Cómo se usa? — libro abierto
  libro: <><path d="M12 6.5C10 5 7 4.5 3 5v13c4-.5 7 0 9 1.5" /><path d="M12 6.5c2-1.5 5-2 9-1.5v13c-4-.5-7 0-9 1.5" /><line x1="12" y1="6.5" x2="12" y2="19.5" /></>,
  // fallback
  punto: <><circle cx="12" cy="12" r="2.5" /></>,
};

export function Icono({ nombre, size = 17, className = "" }) {
  const trazo = TRAZOS[nombre] || TRAZOS.punto;
  return (
    <svg
      className={"hub-ico " + className} width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
    >
      {trazo}
    </svg>
  );
}

/* Qué ícono va en cada universo del hub. */
const POR_UNIVERSO = {
  Tráfico: "trafico",
  YPF: "surtidor",
  Fueguino: "caja",
  "Mi espacio": "grilla",
  Automatizaciones: "rayo",
  Novedades: "campana",
  "¿Cómo se usa?": "libro",
  Padrones: "gente",
  Peajes: "barrera",
  Pañol: "panol",
  Portería: "escudo",
  Comprobantes: "recibo",
  Proveedores: "billete",
  Aduana: "sello",
  Seguros: "escudo",
  Dirección: "brujula",
  Presidencia: "grafico",
  Puerto: "ancla",
  RRHH: "credencial",
  Sistema: "engranaje",
  TCC: "edificio",
  Taller: "llave",
};

export const iconoDeUniverso = (universo) => POR_UNIVERSO[universo] || "punto";

export default Icono;
